import translations from './translations.json'

export class Translate {
	constructor(path, lang) {
		this.path = path
		this.lang = lang
	}

	getWord() {
		return (word) => {
			let keyWord = word.replace(/\n/g, `\\n`);

			if (translations[this.path] &&
				translations[this.path][keyWord] &&
				translations[this.path][keyWord][this.lang]
			) {
				return translations[this.path][keyWord][this.lang];
			}

			return word;
		}
	}
}